import { createApp } from "vue";
// Глобальные правила видимой области / клавиатуры. Подключаем ровно один раз,
// чтобы они не дублировались через scoped-импорты main.scss.
import "@/assets/style/viewport.scss";
import "@/assets/style/animations.scss";
import App from "./App.vue";
import { i18n } from "@/i18n";
import router from "./router";
import store, { key } from "@/store";
import AuthLayout from "@/layouts/AuthLayout.vue";
import MainLayout from "@/layouts/MainLayout.vue";
import PrimeVue from "primevue/config";
import { requestPushPermission } from "@/services/push-notifications.service";

createApp(App)
  .component("MainLayout", MainLayout)
  .component("AuthLayout", AuthLayout)
  .use(store, key)
  .use(router)
  .use(i18n)
  .use(PrimeVue, {
    cssLayer: {
      name: "primevue",
      order: "app-styles, primevue, another-css-library",
    },
  })
  .mount("#app");

requestPushPermission();
